import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideSpaceBlockData from '../../../Models/Content/GenericGuideSpaceBlockData';
import GenericGuideSpace from './GenericGuideSpaceBlock';

export default class GenericGuideSpaceBlock extends EpiComponent<GenericGuideSpaceBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-space-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideSpace iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

